'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { ChevronDownXs } from '@lichtblick/photon/icons/arrows/chevron-down-xs';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { NavigationItem } from './NavigationItem';
import styles from './secondary-navigation.module.scss';
export const SecondaryNavigation = ({ children, isButtonIntroOnDesktop = false, secondaryNavigation, title })=>{
    const [isOpen, setIsOpen] = useState(false);
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    const navigation = useRef(null);
    useEffect(()=>{
        const observer = new IntersectionObserver((entries)=>entries.forEach((entry)=>{
                setIsButtonVisible(!entry.isIntersecting);
            }));
        const sibling = navigation.current?.nextElementSibling;
        if (sibling) {
            observer.observe(sibling);
            return ()=>observer.unobserve(sibling);
        }
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        "data-testid": "secondary-navigation",
        ref: navigation,
        children: /*#__PURE__*/ _jsxs("section", {
            className: styles.section,
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    size: "l",
                    className: styles.title,
                    bold: true,
                    children: title
                }),
                Boolean(secondaryNavigation?.length) && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: styles['navigation-toggle'],
                            onClick: ()=>setIsOpen(!isOpen),
                            tabIndex: -1,
                            children: /*#__PURE__*/ _jsx(ChevronDownXs, {
                                className: classNames(styles.icon, isOpen && styles.toggled)
                            })
                        }),
                        /*#__PURE__*/ _jsx("menu", {
                            className: classNames(styles.navigation, isOpen && styles.open),
                            children: secondaryNavigation.map((item)=>/*#__PURE__*/ _jsx(NavigationItem, {
                                    ...item
                                }, item.href))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            "aria-hidden": "true",
                            className: classNames(styles.overlay, isOpen && styles.visible),
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                Boolean(children) && /*#__PURE__*/ _jsx("div", {
                    className: classNames(styles['button-wrapper'], isButtonIntroOnDesktop && styles['button-intro'], isButtonVisible && styles.visible),
                    children: children
                })
            ]
        })
    });
};

//# sourceMappingURL=SecondaryNavigation.js.map